// extracted by mini-css-extract-plugin
export default {"title":"PayInfo_title__-hr2R","period":"PayInfo_period__munH1","fee":"PayInfo_fee__tTb8S"};